import { MarkdownToHTML } from "../components/MarkdownToHTML";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

export default function Test() {
  useDocumentTitle("Test");
  return (
    <div>
      <h1 className="text-2xl font-bold dark:text-zinc-100">Test</h1>
      <p className="text-sm text-gray-500 dark:text-zinc-400">
        This is a test page to test the graph chart component.
      </p>

      <MarkdownToHTML
        markdown={`
# Hello
This is a test

| Header 1 | Header 2 |
| -------- | -------- |
| Cell 1   | Cell 2   |
| Cell 3   | Cell 4   |
        `}
      />
    </div>
  );
}
